import { EmployeeRestaurant } from '@/contexts/user-context';
import { useLocationPickerFilterPills } from './use-location-picker-filter-pills';
import { useMemo } from 'react';
import { useMultiSearchFilters } from './use-multi-search-filters';

export const getSearchableFields = (restaurant: EmployeeRestaurant) => [
  restaurant.name,
  restaurant.addressString,
  restaurant.accountID || '',
];

export const useLocationPickerData = (
  restaurantRelationships: EmployeeRestaurant[],
) => {
  const {
    filteredData: searchedData,
    onDisplayTextChange,
    clearSearch,
    searchText,
    searching,
  } = useMultiSearchFilters<EmployeeRestaurant>({
    data: restaurantRelationships,
    getSearchableFields,
  });

  const {
    accountModeFilter,
    dataStatus,
    getPillRef,
    hasMultipleSuppliers,
    pillButtonProps,
    multiSelectFilters,
    refetchDataStatus,
    restaurantRelationships: filteredRestaurantRelationships,
    syncedRestaurantUUIDs,
  } = useLocationPickerFilterPills(searchedData);

  return useMemo(
    () => ({
      accountModeFilter,
      clearSearch,
      dataStatus,
      filteredRestaurantRelationships,
      getPillRef,
      hasMultipleSuppliers,
      multiSelectFilters,
      onDisplayTextChange,
      pillButtonProps,
      refetchDataStatus,
      searching,
      searchText,
      syncedRestaurantUUIDs,
    }),
    [
      accountModeFilter,
      clearSearch,
      dataStatus,
      filteredRestaurantRelationships,
      getPillRef,
      hasMultipleSuppliers,
      multiSelectFilters,
      onDisplayTextChange,
      pillButtonProps,
      refetchDataStatus,
      searching,
      searchText,
      syncedRestaurantUUIDs,
    ],
  );
};
